var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-space"},[_c('div',{staticClass:"echarts-layout",attrs:{"id":_vm.echartId}}),(_vm.isEmptyData)?_c('EmptyData'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }